import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIdCopy } from "@hooks/useIdCopy";

export const BillNumberCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Bill, string | null>) => {
        const { getCopyProps } = useIdCopy({ label: "Bill" });
        const bill = row.original;

        return (
            <ViewTableCell>
                <span {...getCopyProps(bill.id)}>{bill.invoiceNumber}</span>
            </ViewTableCell>
        );
    },
);
